"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class TwingReflectionParameter {
    constructor(name, defaultValue) {
        this.optional = false;
        this.name = name;
        this.defaultValue = defaultValue;
    }
    isDefaultValueAvailable() {
        return (this.defaultValue !== undefined);
    }
    getName() {
        return this.name;
    }
    getDefaultValue() {
        return this.defaultValue;
    }
    isArray() {
        // type hinting, used by PHP to support that function, does not exist in JavaScript
        // if we have a default value, we test its type against Array
        // else we return true since any parameter can potentially be an array
        if (this.isDefaultValueAvailable()) {
            return Array.isArray(this.getDefaultValue());
        }
        return true;
    }
    isOptional() {
        return this.optional;
    }
    setOptional(flag) {
        this.optional = flag;
    }
}
exports.TwingReflectionParameter = TwingReflectionParameter;
